<template>
    <div class="news-detail">
        <!-- <div class="news-header"><img :src="content.logo"/></div>
        <div class="news-line"></div> -->
        <div class="news-content">
            <div class="title" v-if="content.contentTitle">{{content.contentTitle}}</div>
            <div class="content" v-html="content.content"></div>
        </div>
    </div>
</template>

<script>
export default {
    name:'NewsDetail',
    data(){
        return {
           content:{},
           contentId:''
        }
    },
    created(){
        this.contentId = this.$route.query.contentId;
        if(!this.$route.query.contentId){
            MessageBox.alert("缺少参数 columnId");
            return;
        }
    },
    mounted(){
        this.getNewsDetail();
    },
    methods:{
        getNewsDetail(){
            const self = this;
            this.$http.get("/bicycle/inter/newsDetail?contentId="+this.contentId).then(function(res){
                if(res.data.status != 200){
                    MessageBox.alert(res.data.errorMsg);
                }else{
                    self.content = res.data.data;
                }
            }).catch(function(error){
                console.log(error)
            });
        }
    }
}
</script>

<style scoped>
.news-detail{
    width: 100%;
    margin: 0 auto;
    overflow: hidden;
    margin-top: 24px;
    margin-bottom: 24px;
}
.news-header{
    text-align: center;
    margin-bottom: 6px;
}
.news-header img{
    height: 20px;
}
.news-line{
    border-top: 1px dashed #2E3855;
    margin-bottom: 6px;
    width: 80%;
    margin: 0 auto;
}
.news-content{
    width: 80%;
    overflow:auto;
    margin: 0 auto;
}
.news-content >>> img{
    max-width: 100%;
}
.title{
    line-height: 16px;
    font-size: 16px;
    font-weight: bold;
    margin-top: 12px;
    margin-bottom: 12px;
    text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/pages/MobileNewsDetail.vue